import { ISP_Room } from './types'
import { OperatorPanelWrapperFullSize, } from '../../components/Layout'
import { RoomQuality } from './RoomQuality'
import { IAutomationObject } from '../../types';
import { isParameterApp } from '../../parameterApps';
import { OperationModeDisplay } from './OperationModeDisplay';
import ActiveLightsPanel from '../../Devices/Light/ActiveLightsPanel';
import { LoadingView } from '../../../components';
import { FilteredAppsView } from '../../components/FilteredAppsView';
import { FormattedMessage } from 'react-intl';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { schema as schemaMultistate } from '../../Devices/MultiState/types'
import { schema as schemaMultiStateSwitch } from '../../Devices/MultiStateSwitch/types'
import { schemaTemperature, schemaHumidity, schema as schemaSensorAnalog } from '../../Devices/SensorAnalog/types'


export function OperatorPanel(props: ISP_Room) {
    const { children, error, isLoading, isSuccess } = useGetObjectsChildren(props.resourceGroupId, props.id);

    return (
        <OperatorPanelWrapperFullSize resourceGroupId={props.resourceGroupId} objectId={props.id}
            statusContent={<>
                <OperationModeDisplay {...props}></OperationModeDisplay>
                <RoomQuality {...props}></RoomQuality>
                <ActiveLightsPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></ActiveLightsPanel>
            </>}>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <FilteredAppsView header={<FormattedMessage id="SP_Room.roomSensors" defaultMessage={'Room sensors'} />} apps={children ?? []} filter={sensorFilter}></FilteredAppsView>
                <FilteredAppsView header={<FormattedMessage id="P_CoolingHeating.PlantSwitch" defaultMessage={'Status'} />} apps={children ?? []} filter={msFilter}></FilteredAppsView>
                <FilteredAppsView apps={children ?? []} filter={allTheRestFilter}></FilteredAppsView>
            </LoadingView>
        </OperatorPanelWrapperFullSize>
    );
}

const msFilter = (a: IAutomationObject) => {
    return a.schema === schemaMultistate || a.schema === schemaMultiStateSwitch;
}

const sensorFilter = (a: any) => {
    return a.schema === schemaTemperature || a.schema === schemaHumidity
    || (a.schema === schemaSensorAnalog && a.dimension === 'ppm');
}

const allTheRestFilter = (a: IAutomationObject) => {
    return !msFilter(a) && !sensorFilter(a)
        && !isParameterApp(a.schema);
}
